import useSWR from 'swr'

import { MutationOptions, useCallMutation } from '@/common/api/client'
import { apiDefaultFetcher, apiDeleteFetcher, apiPutFetcher } from '@/common/api/fetcher'
import {
  CreateLinkageApiKeyResponse,
  CreateLinkageApiKeyVars,
  DeleteLinkageApiKeyResponse,
  DeleteLinkageApiKeyVars,
  LinkageApiKeyApiPath,
  ListLinkageApiKeysResponse,
  ListLinkageApiKeysVars,
  UpdateLinkageApiKeyResponse,
  UpdateLinkageApiKeyVars
} from '@/common/api/params/linkageApiKey'

export const useLinkageApiKeyListApi = () => {
  return useSWR<ListLinkageApiKeysResponse, Response, [string, ListLinkageApiKeysVars]>(
    [LinkageApiKeyApiPath.LIST_LINKAGE_API_KEYS, {}],
    apiDefaultFetcher
  )
}

// 一覧APIから1件を導出する（単一取得APIは設けていない）
export const useLinkageApiKeyGetApi = ({
  linkage_api_key_id
}: {
  linkage_api_key_id: number
}) => {
  const response = useLinkageApiKeyListApi()
  return {
    ...response,
    data: response.data ? response.data.find((k) => k.id === linkage_api_key_id) : undefined
  }
}

export const useLinkageApiKeyCreateApi = (
  options?: MutationOptions<CreateLinkageApiKeyResponse>
) => {
  return useCallMutation<CreateLinkageApiKeyResponse, CreateLinkageApiKeyVars>(
    LinkageApiKeyApiPath.CREATE_LINKAGE_API_KEY,
    options
  )
}

export const useLinkageApiKeyUpdateApi = (
  options?: MutationOptions<UpdateLinkageApiKeyResponse>
) => {
  return useCallMutation<UpdateLinkageApiKeyResponse, UpdateLinkageApiKeyVars>(
    LinkageApiKeyApiPath.UPDATE_LINKAGE_API_KEY,
    options,
    apiPutFetcher
  )
}

export const useLinkageApiKeyDeleteApi = (
  options?: MutationOptions<DeleteLinkageApiKeyResponse>
) => {
  return useCallMutation<DeleteLinkageApiKeyResponse, DeleteLinkageApiKeyVars>(
    LinkageApiKeyApiPath.DELETE_LINKAGE_API_KEY,
    options,
    apiDeleteFetcher
  )
}
